<template lang="pug">
  div.access.user-groups-update
    e-form-modal(
    ref="modalForm"
     @submitModalForm="sendForm()"
     @deleteItem="deleteItem()"
     :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs
      slot
          e-form(:formValidator="formValidator")
            div
                div.body
                  div.col
                    e-form-group(
                      name="name"
                      inputType="input"
                      label="Категория"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                    )
                  div.col
                   div
                div.body
                  div.col
                    e-form-group(
                      name="calculation_unit_id"
                      inputType="select"
                      label="Мера учета"
                      :model="fields"
                      :options="calculationModulesSorted"
                      tabView="tab1"
                      :required="true"
                    )
                  div.col
                  div
                  div
                div.body
                  div.col
                    e-form-group(
                      name="code"
                      inputType="input"
                      label="Code"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                    )
                  div.col
                  div
                div.body
                  div.col
                    e-form-group(
                      name="kg_month"
                      inputType="input"
                      label="кг. в месяц"
                      :model="fields"
                      tabView="tab1"
                      validationRule="number"
                    )
                    div.body
                  div.col
                    e-form-group(
                      name="cub_month"
                      inputType="input"
                      label="куб. в месяц"
                      :model="fields"
                      tabView="tab1"
                      validationRule="number"
                    )
                  div.col
                  div.col

                  div
                div.body
                  div.col
                    e-form-group(
                      name="kg_year"
                      inputType="input"
                      label="кг. в год"
                      :model="fields"
                      tabView="tab1"
                      validationRule="number"
                    )
                    div.body
                  div.col
                    e-form-group(
                      name="cub_year"
                      inputType="input"
                      label="куб. в год"
                      :model="fields"
                      tabView="tab1"
                      validationRule="number"
                    )
                  div.col
                   div.col
                  div.col

                  //div.col
                  //div.col



</template>

<script>
import {access, atu, core, garbage, map as mapEndpoints, standarts, threads, tko} from '../../api/api-endpoints.js'
  import adminForm from './mixins/admin-form.js'
  // import formBaseMixin from '../../components/form/form-base-mixin.js'
  import url from "../../utils/url";
  import {ACTION_TYPES} from "../../config/config";

  const FilterModel = () => ({
  })

  export default {
    mixins: [adminForm],
    data () {
      return {
        filterModel: new FilterModel(),
      }
    },
    computed: {
      ACTION_TYPES () {
        return ACTION_TYPES
      },
      collections () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      calculationModules () {
        return this.collections.calculation_unit || []
      },
      calculationModulesSorted () {
        return this.calculationModules.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      },
    },
    methods: {
      update () {
        adminForm.methods.update.call(this)
      },
      // send post for correct change status and avatar
      getStoreAction () {
        return 'createModel'
      },
      getRolesUrl () {
        return access.groups()
      },
      getDeleteUrl (id){
        return garbage.garbageCategoryDelete(id)
      },
      getUpdateOrCreateUrl(route) {
        return garbage.garbageCategoryUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route){
        console.log(route.params.id);
        if (!route.params.id) {
          return null
        }
        return garbage.garbageCategoryUpdateOrCreate(route.params.id);
      },
      getCollectionEndpoint () {
        return core.collection('calculation_unit')
      },
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []
      // promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getEndpoint(route, fromRoute)}))
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint()}))
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route)}))

      return Promise.all(promises)
    }
  }
</script>
